
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "Tabs",
  props: {
    items: {
      type: Array as PropType<{ title: string; path: string }[]>,
      required: true,
    },
  },
});
